import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import EmailCloneBusinessUnit from 'email-management-lib/EmailClone/components/EmailCloneBusinessUnit';
import EmailCloneSettings from 'email-management-lib/EmailClone/components/EmailCloneSettings';
import EmailCloneTypeButtons from 'email-management-lib/EmailClone/components/EmailCloneTypeButtons';
import EmailTemplateRadioInputs from 'email-management-lib/EmailClone/components/EmailTemplateRadioInputs';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PrimaryClonePanelBody({
  email,
  selectedABVersion,
  emailName,
  onChangeEmailName,
  canAccessBusinessUnit,
  onSelectBusinessUnit,
  buId,
  selectedEmailType,
  onSelectType,
  isConvertible,
  onSelectTemplateMode,
  selectedTemplateMode,
  smartContentLocations,
  variantSmartContentLocations,
  hasCustomPlaintext,
  variantHasCustomPlaintext,
  onSelectPermissions,
  onSelectPlaintext,
  onSelectSmartContent,
  cloneWithSmartContent,
  cloneWithCustomPlaintext,
  retainPermissionsAfterClone,
  teamName,
  teamCount,
  userCount,
  assignedCustomProperties
}) {
  if (email.isABLike() && !selectedABVersion) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.emailClone.cloneSidePanel.sections.emailName.label"
      }),
      children: /*#__PURE__*/_jsx(UITextInput, {
        value: emailName,
        onChange: onChangeEmailName
      })
    }), /*#__PURE__*/_jsx(EmailCloneBusinessUnit, {
      canAccessBusinessUnit: canAccessBusinessUnit,
      onSelect: onSelectBusinessUnit,
      buId: buId
    }), /*#__PURE__*/_jsx(EmailCloneTypeButtons, {
      email: email,
      selectedEmailType: selectedEmailType,
      onSelectType: onSelectType
    }), /*#__PURE__*/_jsx(EmailTemplateRadioInputs, {
      email: email,
      isConvertible: isConvertible,
      onSelectTemplateMode: onSelectTemplateMode,
      selectedTemplateMode: selectedTemplateMode
    }), /*#__PURE__*/_jsx(EmailCloneSettings, {
      isAbEmail: email.isABLike(),
      selectedABVersion: selectedABVersion,
      smartContentLocations: smartContentLocations,
      variantSmartContentLocations: variantSmartContentLocations,
      hasCustomPlaintext: hasCustomPlaintext,
      variantHasCustomPlaintext: variantHasCustomPlaintext,
      onSelectPermissions: onSelectPermissions,
      onSelectPlaintext: onSelectPlaintext,
      onSelectSmartContent: onSelectSmartContent,
      cloneWithSmartContent: cloneWithSmartContent,
      cloneWithCustomPlaintext: cloneWithCustomPlaintext,
      retainPermissionsAfterClone: retainPermissionsAfterClone,
      teamName: teamName,
      teamCount: teamCount,
      userCount: userCount,
      assignedCustomProperties: assignedCustomProperties
    })]
  });
}
export default PrimaryClonePanelBody;